// @flow

import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import ParticipantIndicator from '@shared/ParticipantIndicator';
import IconCircleExclamation from '@icons/components/IconCircleExclamation';

import type { ShortRegistered } from '@groupClass/types';
import { WEB_PATHS } from '@app/constants/paths';
const { PARTICIPANTS_REGISTERED_ID } = WEB_PATHS;

type Props = {
  registered: ShortRegistered,
};

type UseParamProps = {
  classId: string,
  registeredId: string,
};

const ListRegisteredRow = (props: Props): React$Node => {
  const { registered } = props;
  const { t } = useTranslation();
  const { classId: id, registeredId } = useParams<UseParamProps>();
  const person = registered.person;
  const {
    firstName = '',
    lastName = '',
    type = '',
    shapeUser = false,
  } = person;

  const lastNameFormatted = lastName.toUpperCase();
  const label = `${ firstName } ${ lastNameFormatted }`;
  const isBeneficiary = type === 'beneficiary';
  const hasAcceptedGroupClassTerms = isBeneficiary && !!person.groupClassTermsAcceptedAt;

  const listRegisteredsGroupClassesRegisteredsClassName = clsx({
    'people': true,
    'list-registered-request': true,
    'is-selected': String(registered.id) === registeredId,
  });

  return (
    <li className={ listRegisteredsGroupClassesRegisteredsClassName }>
      <Link to={ PARTICIPANTS_REGISTERED_ID.replace(':classId', id).replace(':registeredId', String(registered.id)) } >
        <div className="list-registereds-line-people">
          <ParticipantIndicator isBeneficiary={ isBeneficiary } isShapeUser={ shapeUser } />
          { !hasAcceptedGroupClassTerms && (
            <span
              aria-label={ t('groupClasses.groupClass.peoples.list.cgvNotSigned') }
              className="list-registereds-cgv-indicator"
              title={ t('groupClasses.groupClass.peoples.list.cgvNotSigned') }
            >
              <IconCircleExclamation />
            </span>
          ) }
          <span className="list-registereds-name" title={ label }>{ label }</span>
        </div>
      </Link>
    </li>
  );
};

export default ListRegisteredRow;
